'use strict';

var BaseLayer = require('./base/BaseLayer');
var Geometry = require('../utils/Geometry');
var PathEventMixin = require('./mixins/PathEventMixin');
var PathStyleMixin = require('./mixins/PathStyleMixin');

var RectangleLayer = BaseLayer.extend([PathEventMixin, PathStyleMixin, {

  initialize: function () {
    this.registerPathEventListeners();

    this._fixRectangleEditControls();
  },

  setStyle: function (style) {
    this.leafletLayer.setStyle(style);
  },

  _fixRectangleEditControls: function () {
    // FIX Layer Editing handler
    // Since GeoJson does not have a Rectangle type, we need to override the edit
    // capabilities for a standard polygon layer
    var leafletLayer = this.leafletLayer;

    if(leafletLayer.editing) {
      leafletLayer.editing = new L.Edit.Rectangle(leafletLayer);
      leafletLayer.setBounds = function(latLngBounds) {
        latLngBounds = L.latLngBounds(latLngBounds);
        var bounds = [
          latLngBounds.getSouthWest(),
          latLngBounds.getNorthWest(),
          latLngBounds.getNorthEast(),
          latLngBounds.getSouthEast()
        ];
        return this.setLatLngs(bounds);
      };
    }
  },

  _getPopupLatLng: function () {
    var leafletLayer = this.leafletLayer;
    return leafletLayer.getBounds().getCenter();
  },

  /**
   * Set leafletLayer style to highlighted
   */
  _setStateStyleToActive: function () {
    var style = this.styles.active;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to its default
   */
  _setStateStyleToDefault: function () {
    var style = this.styles.default;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to dimmed
   */
  _setStateStyleToDim: function () {
    var style = this.styles.dim;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  _updateMeasurements: function () {
    var area, circum;

    circum = Geometry.circumference('rectangle', this.layer.data);
    this.layer.circumference = circum;
    this.layer.data.properties.circumference = circum;

    // TODO Should the area be on the GeoJSON properties OR or one level up? Or both?
    area = Geometry.area('rectangle', this.layer.data);
    this.layer.area = area;
    this.layer.data.properties.area = area;
    this.leafletLayer.fire('measurements:updated');
  }

}]);

module.exports = RectangleLayer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/RectangleLayer.js